"use strict";

var $ = require("jquery");
var moment = (window.moment = require("moment"));
var stringify = require("json-stringify-safe");
window.fullcalendar = require("fullcalendar");
var ProductHelperDep = require("./helpers/product_selection_render_helper");
var BookingHelperDep = require("./helpers/booking_page_render_helper");
require("moment-timezone/builds/moment-timezone-with-data-10-year-range.js");
require("moment/locale/de.js");
require("fullcalendar/dist/fullcalendar.css");
require("./styles/fullcalendar.scss");
require("./styles/utils.scss");
require("./styles/main.scss");
require("./styles/testmoderibbon.scss");

var timezones = require("./timezones");

function InitRender(deps) {
    var utils = deps.utils;
    var sdk = deps.sdk;
    var getConfig = deps.config.getConfig;
    var productRenderHelper = new ProductHelperDep({
        config: deps.config,
        utils: utils,
        sdk: sdk
    });
    var bookingRenderHelper = new BookingHelperDep({
        config: deps.config,
        utils: utils,
        sdk: sdk,
    });

    // DOM nodes
    var rootTarget;
    var calendarTarget;
    var loadingTarget;
    var errorTarget;

    // State
    var customerTimezone;

    // Make sure DOM element is ready and clean it
    var prepareDOM = function (suppliedConfig) {
        var targetElement = suppliedConfig.el || getConfig().el;

        rootTarget = $(targetElement);

        if (rootTarget.length === 0) {
            throw triggerError("No target DOM element was found (" + targetElement + ")");
        }

        rootTarget.addClass("bookingjs");
        rootTarget.children(":not(script)").remove();

        productRenderHelper.setRootTarget(rootTarget);
        bookingRenderHelper.setRootTarget(rootTarget);
    };

    var renderProductSelection = function () {
        productRenderHelper
            .timumFetchProducts()
            .then(function (response) {
                hideLoadingScreen();
            })
            .catch(function (e) {
                hideLoadingScreen();
            });
    };

    // Universal functional to retrieve availability through either findtime or group booking slots
    var getAvailability = function () {
        showLoadingScreen();

        calendarTarget.fullCalendar("removeEventSources");

        timumFetchBookables();
    };

    // Fetch availabile time through timum SDK
    var timumFetchBookables = function () {
        var args = {
            output_timezone: customerTimezone,
            channelKey: getConfig().resource_channel
        };

        if (getConfig().timeFormat) args.timeFormat = getConfig().timeFormat;
        if (getConfig().groupFormat) args.groupFormat = getConfig().groupFormat;

        utils.doCallback("timumFetchBookablesStarted", getConfig(), args);

        sdk.getTimeslots(args)
            .then(function (response) {
                utils.doCallback("timumFetchBookablesSuccessful", getConfig(), response);
                hideLoadingScreen();
                var parsedDates = parseBookables(response.data);

                // Render available timeslots in FullCalendar
                getConfig().unfilteredEvents = parsedDates;

                // Render test ribbon if enabled
                if (response.headers["timum-testmode"]) renderTestModeRibbon();

                if(getConfig().selectedProduct){
                    renderCalendarEvents(productRenderHelper.filterEventData(parsedDates));
                }
            })
            .catch(function (response) {
                utils.doCallback("timumFetchBookablesFailed", getConfig(), response);
                hideLoadingScreen();

                if(response.response.status === 404){
                    triggerError("Unable to fetch products. Please make sure the resourceId you specified is correct.");
                } else {
                    triggerError(["Unable to fetch products.", response]);
                }
            });
    };

    var parseBookables = function (data) {
        var parsedDates = [];

        for (var i = 0; i < Object.keys(data).length; i++) {
            var bookables = data[Object.keys(data)[i]];
            for (var j = 0; !utils.isBoolean(bookables) && j < bookables.length; j++) {
                var bookable = bookables[j];
                if (bookable) {
                    parsedDates.push(bookable);
                }
            }
        }

        return parsedDates;
    };

    // Display ribbon if in testmode
    var renderTestModeRibbon = function () {
        var template = require("./templates/testmoderibbon.html");

        var testModeRibbonTarget = $(
            template.render({
                ribbonText: "Test Mode"
            })
        );

        rootTarget.append(testModeRibbonTarget);
    };

    // Render the supplied calendar events in FullCalendar
    var renderCalendarEvents = function (eventData) {
        if(eventData && eventData.length > 0){
            var firstEventStart = moment(eventData[0].start);
            var firstEventEnd = moment(eventData[0].end);
            var firstEventDuration = firstEventEnd.diff(firstEventStart, "minutes");
    
            if (firstEventDuration <= 90) {
                calendarTarget.fullCalendar("option", "slotDuration", "00:15:00");
            }
    
            calendarTarget.fullCalendar("removeEventSources"); // remove old events, if any, so there are no duplicates
            calendarTarget.fullCalendar("addEventSource", {
                events: eventData
            });
    
            calendarTarget.removeClass("empty-calendar");
    
            // Go to first event if enabled
            goToFirstEvent(eventData[0].start);
        } else {
            utils.logError(" called renderCalendarEvents without eventData.");
        }

        productRenderHelper.renderChooseProductButton();
    };

    // Go to the first timeslot in a list of timeslots
    var goToFirstEvent = function (firstEventStart) {
        calendarTarget.fullCalendar("gotoDate", firstEventStart);

        var firstEventStartHour = moment(firstEventStart).format("H");
        scrollToTime(firstEventStartHour);
    };

    // Scrolls fullcalendar to the specified hour
    var scrollToTime = function (time) {
        // Only proceed for agendaWeek view
        if (calendarTarget.fullCalendar("getView").name !== "agendaWeek") {
            return;
        }

        // Get height of each hour row
        var slotDuration = calendarTarget.fullCalendar("option", "slotDuration");
        var slotDurationMinutes = 30;
        if (slotDuration) slotDurationMinutes = slotDuration.slice(3, 5);
        var hours = calendarTarget.find(".fc-slats .fc-minor");
        var hourHeight = $(hours[0]).height() * (60 / slotDurationMinutes);

        // If minTime is set in fullCalendar config, subtract that from the scollTo calculationn
        var minTimeHeight = 0;
        if (getConfig().fullcalendar.minTime) {
            var minTime = moment(getConfig().fullcalendar.minTime, "HH:mm:ss").format("H");
            minTimeHeight = hourHeight * minTime;
        }

        // Calculate scrolling location and container sizes
        var scrollTo = hourHeight * time - minTimeHeight;
        var scrollable = calendarTarget.find(".fc-scroller");
        var scrollableHeight = scrollable.height();
        var scrollableScrollTop = scrollable.scrollTop();
        var maximumHeight = scrollable.find(".fc-time-grid").height();

        // Only perform the scroll if the scrollTo is outside the current visible boundary
        if (scrollTo > scrollableScrollTop && scrollTo < scrollableScrollTop + scrollableHeight) {
            return;
        }

        // If scrollTo point is past the maximum height, then scroll to maximum possible while still animating
        if (scrollTo > maximumHeight - scrollableHeight) {
            scrollTo = maximumHeight - scrollableHeight;
        }

        // Perform the scrollTo animation
        scrollable.animate({ scrollTop: scrollTo });
    };

    // Calculate and display timezone helper
    var renderFooter = function () {
        var showTimezoneHelper = getConfig().ui.show_timezone_helper;
        var showCredits = getConfig().ui.show_credits;

        // If neither TZ helper or credits is shown, dont render the footer
        if (!showTimezoneHelper && !showCredits) return;

        var campaignName = "widget";
        var campaignSource = window.location.hostname.replace(/\./g, "-");
        if (getConfig().project_id) {
            campaignName = "embedded-widget";
        }
        if (getConfig().project_slug) {
            campaignName = "hosted-widget";
        }

        var timezoneIcon = require("!svg-inline-loader!./assets/timezone-icon.svg");
        var arrowDownIcon = require("!svg-inline-loader!./assets/arrow-down-icon.svg");
        var timumLogo = require("!svg-inline-loader!./assets/timum-logo.svg");
        var template = require("./templates/footer.html");

        var footerTarget = $(
            template.render({
                timezoneIcon: timezoneIcon,
                arrowDownIcon: arrowDownIcon,
                listTimezones: timezones,
                timumLogo: timumLogo,
                campaignName: campaignName,
                campaignSource: campaignSource,
                showCredits: showCredits,
                showTimezoneHelper: showTimezoneHelper
            })
        );
        rootTarget.append(footerTarget);

        // Set initial customer timezone
        var pickerSelect = $(".bookingjs-footer-tz-picker-select");
        pickerSelect.val(customerTimezone);

        // Listen to changes by the user
        pickerSelect.change(function () {
            setCustomerTimezone(pickerSelect.val());
            $(rootTarget).trigger("customer-timezone-changed");
        });
    };

    // Guess the timezone and set global variable
    var guessCustomerTimezone = function () {
        var tzGuess = moment.tz.guess() || "UTC";
        setCustomerTimezone(tzGuess);

        // Add the guessed customer timezone to list if its unknwon
        var knownTimezone =
            $.grep(timezones, function (tz) {
                return tz.key === customerTimezone;
            }).length > 0;
        if (!knownTimezone) {
            var name = "(" + moment().tz(customerTimezone).format("Z") + ") " + customerTimezone;
            timezones.unshift({
                key: customerTimezone,
                name: name
            });
        }
    };

    // Set timezone
    var setCustomerTimezone = function (newTz) {
        if (!newTz || !moment.tz.zone(newTz)) {
            throw triggerError(["Trying to set invalid or unknown timezone", newTz]);
        }
        customerTimezone = newTz;
    };

    // Setup and render FullCalendar
    var initializeCalendar = function () {
        var sizing = decideCalendarSize(getConfig().fullcalendar.defaultView);

        var args = {
            height: sizing.height,
            eventClick: clickTimeslot,
            eventColor: getConfig().ui.eventColor,
            windowResize: function () {
                var sizing = decideCalendarSize();
                calendarTarget.fullCalendar("changeView", sizing.view);
                calendarTarget.fullCalendar("option", "height", sizing.height);
            }
        };

        $.extend(true, args, getConfig().fullcalendar);
        args.defaultView = sizing.view;

        calendarTarget = $('<div class="bookingjs-calendar empty-calendar">');
        rootTarget.append(calendarTarget);

        calendarTarget.fullCalendar(args);

        $(calendarTarget).find(".fc-left").append();

        $(rootTarget).on("customer-timezone-changed", function () {
            if (!calendarTarget) return;
            getAvailability();
            calendarTarget.fullCalendar("option", "now", moment().tz(customerTimezone).format());
        });

        utils.doCallback("fullCalendarInitialized", getConfig());
    };

    // Clicking a timeslot
    var clickTimeslot = function (eventData) {
        if (!getConfig().disable_confirm_page) {
            bookingRenderHelper.showBookingPage(eventData, customerTimezone);
        } else {
            $(".fc-event-clicked").removeClass("fc-event-clicked");
            $(this).addClass("fc-event-clicked");
            utils.doCallback("clickTimeslot", getConfig(), eventData);
        }
    };

    // Fires when window is resized and calendar must adhere
    var decideCalendarSize = function (currentView) {
        currentView = currentView || calendarTarget.fullCalendar("getView").name;

        var view = getConfig().fullcalendar.defaultView;
        var height = 385;

        if (rootTarget.width() < 480) {
            rootTarget.addClass("is-small");
            if (getConfig().ui.avatar) height -= 15;
            if (currentView === "agendaWeek" || currentView === "basicDay") {
                view = "basicDay";
            }
        } else {
            rootTarget.removeClass("is-small");
        }

        $.each(getConfig().customer_fields, function (key, field) {
            if (field.format === "textarea") height += 98;
            else if (field.format === "checkbox") height += 51;
            else height += 66;
        });

        return {
            height: height,
            view: view
        };
    };

    // Render the avatar image
    var renderAvatarImage = function () {
        var template = require("./templates/user-avatar.html");
        var avatarTarget = $(
            template.render({
                image: getConfig().ui.avatar
            })
        );

        rootTarget.addClass("has-avatar");
        rootTarget.append(avatarTarget);
    };

    // Render the avatar image
    var renderDisplayName = function () {
        var template = require("./templates/user-displayname.html");
        var displayNameTarget = $(
            template.render({
                name: getConfig().ui.display_name
            })
        );

        rootTarget.addClass("has-displayname");
        rootTarget.append(displayNameTarget);
    };

    // Show loading spinner screen
    var showLoadingScreen = function () {
        utils.doCallback("showLoadingScreen", getConfig());

        var template = require("./templates/loading.html");
        loadingTarget = $(
            template.render({
                loadingIcon: require("!svg-inline-loader!./assets/loading-spinner.svg")
            })
        );

        rootTarget.append(loadingTarget);
    };

    // Remove the booking page DOM node
    var hideLoadingScreen = function () {
        utils.doCallback("hideLoadingScreen", getConfig());
        loadingTarget.removeClass("show");

        setTimeout(function () {
            loadingTarget.remove();
        }, 500);
    };

    // Show error and warning screen
    var triggerError = function (message) {
        // If an error already has been thrown, exit
        if (errorTarget) return message;

        utils.doCallback("errorTriggered", getConfig(), message);
        utils.logError(message);

        // If no target DOM element exists, only do the logging
        if (!rootTarget) return message;

        var messageProcessed = message;
        var contextProcessed = null;

        if (utils.isArray(message)) {
            messageProcessed = message[0];
            if (message[1].data) {
                contextProcessed = stringify(message[1].data.errors || message[1].data.error || message[1].data);
            } else {
                contextProcessed = stringify(message[1]);
            }
        }

        var template = require("./templates/error.html");
        errorTarget = $(
            template.render({
                errorWarningIcon: require("!svg-inline-loader!./assets/error-warning-icon.svg"),
                message: messageProcessed,
                context: contextProcessed
            })
        );

        rootTarget.append(errorTarget);

        return message;
    };

    // Destory fullcalendar and cleanup event listeners etc.
    var destroyFullCalendar = function () {
        if (!calendarTarget || calendarTarget.fullCalendar === undefined) return;
        calendarTarget.fullCalendar("destroy");
    };

    // The fullCalendar object for advanced puppeting
    var fullCalendar = function () {
        if (calendarTarget.fullCalendar === undefined) {
            return undefined;
        }
        return calendarTarget.fullCalendar.apply(calendarTarget, arguments);
    };

    // the helpers need these functions... I really don't know a better alternative
    // if you do, don't hesitate to refactor
    bookingRenderHelper.setRequiredFunctions(getAvailability, triggerError);
    productRenderHelper.setRequiredFunctions(renderCalendarEvents, triggerError);

    return {
        prepareDOM: prepareDOM,
        getAvailability: getAvailability,
        initializeCalendar: initializeCalendar,
        renderAvatarImage: renderAvatarImage,
        renderDisplayName: renderDisplayName,
        renderProductSelection: renderProductSelection,
        triggerError: triggerError,
        fullCalendar: fullCalendar,
        destroyFullCalendar: destroyFullCalendar,
        renderFooter: renderFooter,
        guessCustomerTimezone: guessCustomerTimezone,
        setCustomerTimezone: setCustomerTimezone
    };
}

module.exports = InitRender;
